/**
 * Root application component with TanStack Router.
 */

import { useIsAuthenticated } from "@azure/msal-react";
import { RouterProvider } from "@tanstack/react-router";
import { useRole } from "@/hooks/use-role";
import { router } from "@/routes/router";
import { LoginPage } from "@/pages/login";

export function App() {
  const isAuthenticated = useIsAuthenticated();
  const role = useRole();

  // Show login page when not authenticated (outside router)
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <RouterProvider router={router} context={{ isAuthenticated, role }} />
  );
}
